import * as React from 'react';
import * as purpleBanner from './purpleBanner.module.scss';

export const PurpleBanner = () => {
  return (
    <section className={purpleBanner.purpleBanner}>
      <div className="container">
        <div className={purpleBanner.purpleBanner__container}>
          <h2 className={purpleBanner.purpleBanner__title}>
            Курс «Учись учиться» дает <b>методики усвоения знаний.</b>
          </h2>
          <p className={purpleBanner.purpleBanner__text}>
            Помогает повысить эффективность учебы, развить логику, память и&nbsp;аналитические способности. Учеба будет
            легкой и&nbsp;веселой, а&nbsp;новые навыки помогут стать ответственным, самодостаточным и&nbsp;образованным.
          </p>
        </div>
      </div>
    </section>
  );
};
